<template>
<div class="col col-md-12 pl-0 pr-4 pb-3" id="photospage">
  <div v-for="(img , ind) in images" :key="img.pdphotoid" class="pb-3" :id="`details-photospage${(ind / pagePhotos) + 3}`">
    <div v-if="pagePhotos === 2 && (ind % 2 === 0)" class="innerdoc edit-photospage-two template3 mt-1 mr-2 pb-0" :style="{ height: `${divHeight}` }">
      <div class="header col-md-12 pb-0 pb-lg-2" style="height: 10%">
        <div class="row">
          <div class="col-md-6">
            <img :src="logo_one" class="mb-2 img-fluid logo-images-in-docs" alt="img">
          </div>
          <div class="col-md-6 text-right">
            <img :src="logo_two" class="mb-2 img-fluid logo-images-in-docs" alt="img">
          </div>
        </div>
      </div>
      <div class="body pb-3 pb-xl-4 position-relative" style="height: 90%">
        <div class="row h-50">
          <div class="col-md-6 text-center" style="height: 97%">
            <div class="pb-2 h-100">
              <img :src="`${photoUrl}&projectid=${images[ind].projectid}&id=${images[ind].pdphotoid}`" class="img-fluid" alt="image">
            </div>
          </div>
          <div class="col-md-6" style="height: 97%">
            <div class="mb-1">
              <p>
                Foto-Nr  : {{ images[ind].runid }}
              </p>
              <p>
                Aufnahmedatum : {{images[ind].photodate | date}}
              </p>
              <p>
                Dateiname: {{images[ind].origname}}
              </p>
              <p> Planzuordnung: Nur im PDF sichtbar </p>
            </div>
            <div class="mb-1">
              <p class="font-weight-bold"> Schlagworte :</p>
              <p v-for="tag in images[ind].params" :key="tag.projectparamid">
                {{tag.group}}:  {{tag.name}}
              </p>
            </div>
            <div>
              <p class="font-weight-bold"> Beschreibung : </p>
              <div class="photo-description">
              <p> {{images[ind].pdphototext}} </p>
              </div>
            </div>
          </div>
        </div>

        <div class="row h-50" v-if="images[ind + 1]">
          <div class="col-md-6 pl-1 pr-0 text-center"  style="height: 95%">
            <div class="p-0 h-100">
              <img :src="`${photoUrl}&projectid=${images[ind + 1].projectid}&id=${images[ind + 1].pdphotoid}`" class="img-fluid" alt="image">
            </div>
          </div>
          <div class="col-md-6"  style="height: 95%">
            <div class="mb-1">
              <p>
                Foto-Nr  : {{images[ind + 1].runid}}
              </p>
              <p>
                Aufnahmedatum : {{images[ind + 1].photodate | date}}
              </p>
              <p>
                Dateiname: {{images[ind + 1].origname}}
              </p>
              <p> Planzuordnung: Nur im PDF sichtbar </p>
            </div>
            <div class="mb-1">
              <p class="font-weight-bold"> Schlagworte :</p>
              <p v-for="tag in images[ind + 1].params" :key="tag.projectparamid">
                {{tag.group}} :  {{tag.name}}
              </p>
            </div>
            <div>
              <p class="font-weight-bold"> Beschreibung : </p>
              <div class="photo-description">
              <p>{{images[ind + 1].pdphototext}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2" v-if="images.length === 0">
          <div class="col-md-12 text-center">
            <h4> Fotobeschreibung hinzufügen </h4>
          </div>
        </div>
        <div v-if="images.length > 0" class="stickynav">
          <sliding-pagination
            :current="currentPage"
            :total="Math.ceil(images.length / pagePhotos) + 2"
            @page-change="pageChangeHandler"/>
        </div>

        <p class="text-center border-top position-absolute foot">
          Seite {{ (ind / pagePhotos) + 3  }}  von {{ Math.ceil(images.length / pagePhotos) + 2 }}
          <span class="float-right">projectdocu.com</span>
        </p>
      </div>
    </div>

    <div v-else-if="pagePhotos === 1" class="innerdoc template3 mt-1 edit-photospage mr-3 pb-0" :style="{ height: `${divHeight}` }">
      <div class="header col-md-12 pb-0 pb-lg-2" style="height: 10%">
        <div class="row">
          <div class="col-md-6">
            <img :src="logo_one" class="mb-2 img-fluid logo-images-in-docs" alt="img">
          </div>
          <div class="col-md-6 text-right">
            <img :src="logo_two" class="mb-2 img-fluid logo-images-in-docs" alt="img">
          </div>
        </div>
      </div>
      <div class="body pb-3 pb-xl-4 position-relative" style="height: 90%">
        <div class="row">
          <div class="col-md-12 text-left">
            <div class="pb-2">
              <img :src="`${photoUrl}&projectid=${images[ind].projectid}&id=${images[ind].pdphotoid}`" class="img-fluid single-photo-document" alt="image">
            </div>
          </div>
          <div class="col-md-12 pl-4" style="height: 97%">
            <div class="pl-1">
              <div class="mb-1 mt-1">
                <p>
                  Foto-Nr  : {{ images[ind].runid }}
                </p>
                <p>
                  Aufnahmedatum : {{images[ind].photodate | date}}
                </p>
                <p>
                  Dateiname: {{images[ind].origname}}
                </p>
                <p> Planzuordnung: Nur im PDF sichtbar </p>
              </div>
              <div class="mb-1">
                <p class="font-weight-bold"> Schlagworte :</p>
                <p v-for="tag in images[ind].params" :key="tag.projectparamid">
                  {{tag.group}}:  {{tag.name}}
                </p>
              </div>
              <div>
                <p class="font-weight-bold"> Beschreibung : </p>
                <div class="photo-description">
                  <p> {{images[ind].pdphototext}} </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="images.length === 0">
          <div class="col-md-12 text-center">
            <h4> Fotobeschreibung hinzufügen </h4>
          </div>
        </div>
        <div v-if="images.length > 0" class="stickynav">
          <sliding-pagination
            :current="currentPage"
            :total="Math.ceil(images.length / pagePhotos) + 2"
            @page-change="pageChangeHandler"/>
        </div>

        <p class="text-center border-top position-absolute foot">
          Seite {{ (ind / pagePhotos) + 3  }}  von {{ Math.ceil(images.length / pagePhotos) + 2 }}
          <span class="float-right">projectdocu.com</span>
        </p>
      </div>
    </div>
  </div>



  <div class="stickynav" v-if="pagePhotos === 2">
    <sliding-pagination
      :current="currentPage"
      :total="Math.ceil(images.length / 2) + 2"
      @page-change="pageChangeHandler"/>
  </div>
</div>
</template>
<script>
import SlidingPagination from 'vue-sliding-pagination'
import {mapState} from 'vuex'
import {formatDate} from '../../../common'
export default {
  props: ['theme', 'selectedDocument' , 'logo_one','logo_two'],
  data () {
    return {
      currentPage: 1,
      page: 1,
      is_loading: true,
      index: 0,
      photos: [],
      divHeight: '1200px'
    }
  },
  mounted(){
    this.changeActivePageOnScroll()
    let width = document.querySelector('.innerdoc').offsetWidth
    this.divHeight = `${width * 1.4}px`
  },
  components: { SlidingPagination },
  filters: {
    date: (d) => formatDate(d,true)
  },
  computed: {
    photoUrl: () => `${process.env.VUE_APP_GET_METHOD_URL}img&token=${localStorage.sessiontoken}&PHPSESSID=${localStorage.sessiontoken}&type=l`,
    images() {
        this.currentPage = 1;
        this.index = 0;
        return this.$store.getters.getPhotoContentImages
    },
    ...mapState({
      doc: state => state.photoDocumentation.selectedDocument
    }),
    pageImages () {
      let _this = this
      return this.images.slice(_this.index, _this.index + 2)
    },
    pagePhotos(){
     return this.doc.reportparams.singlephotopage == 1 ? 1 : 2
    }
  },
  methods: {
    pageChangeHandler (selectedPage) {
      if (selectedPage === 1){
        // Scroll to cover page
        this.currentPage = selectedPage
        document.getElementById("coverpage").scrollIntoView({ behavior: "smooth" });
      }else if (selectedPage === 2){
        //Scroll to the text page
        this.currentPage = selectedPage
        document.getElementById("textpage").scrollIntoView({ behavior: "smooth" });
      }else {
        //Scroll to the Photo page
        document.getElementById(`details-photospage${selectedPage}`).scrollIntoView({ behavior: "smooth" });
        this.currentPage = selectedPage
        this.page = selectedPage
        this.index = ((selectedPage - 3) * 2);
      }
    },

    /**
     * Change active page when user scroll the pages
     */
    changeActivePageOnScroll(){
      let _this = this
      document.querySelector('#preview-docs').onscroll = function (e){
        let  scroll_val = e.target.scrollTop
        let page_height = document.querySelector('#coverpage').offsetHeight
        let page = Math.floor((scroll_val / page_height)) + 1
        if (page > _this.currentPage){
          _this.currentPage = page
        }else if(page < _this.currentPage){
          _this.currentPage = page
        }
      }
    }
  }
}
</script>
<style scoped>
.edit-photospage img{
  max-height: 37rem !important;
}
.edit-photospage-two img{
  max-height: 100% !important;
}
.photo-description{
  max-height: 15vh;
  padding-left: 3px;
  border-left: 1px solid lightgrey;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scroll-behavior: smooth;
}
.single-photo-document{
  padding: 1px 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/Preview/PreviewPhotosContent.vue